import ActionUtility from "../ActionUtility";

export default class FavoritesAction {
  static UPDATE_FAVORITES_STATE = "DotsAction.UPDATE_FAVORITES_STATE";

  static SET_FAVORITES = "FavoritesAction.SET_FAVORITES";
  static GET_FAVORITES = "FavoritesAction.GET_FAVORITES";


  static updateFavoritesState(action) {
    return ActionUtility.createAction(FavoritesAction.UPDATE_FAVORITES_STATE, action);
  }

  /* Set or Unset Favorites */
  static setFavorites(targetId, targetType, flag = true, callback) {
    return ActionUtility.createAction(FavoritesAction.SET_FAVORITES, {targetId, targetType, flag, callback});
  }

  /*Get list of Favorites*/
  static getFavorites(targetType, callback) {
    return ActionUtility.createAction(FavoritesAction.GET_FAVORITES, {targetType, callback});
  }


}
